import { useState, useEffect } from "react";

export function Checkbox({ value, selectedCategory, setSelectedCategory, uncheck }) {
    const [checked, setChecked] = useState(selectedCategory === value);

    let removeCategory = (categoryId) => {
        let index = selectedCategory.indexOf(categoryId);
        if (index !== -1) {
            selectedCategory.splice(index, 1);
            setSelectedCategory([...selectedCategory]);
        }
    };

    useEffect(() => {
        if (uncheck) {
            setChecked(false);
        }
    }, [uncheck]);

    return (
        <input
            type="checkbox"
            value={value}
            checked={checked}
            onChange={(e) => {
                // Unchecks the current Checkbox.
                // selectedCategory.setChecked(false);

                if (e.target.checked) setSelectedCategory([...selectedCategory, value]);
                else removeCategory(value);

                // Toggles this Checkbox.
                setChecked(!checked);
            }}
        />
    );
}
